import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PaginationData } from "../../pages/GoalsPage";

const GoalsPagination: React.FC<{
    pagination: PaginationData | null;
    onPageChange: (page: number) => void;
}> = ({ pagination, onPageChange }) => {
    const { t } = useTranslation();

    const safePagination = pagination || {
        page: 1,
        totalPages: 1,
        limit: 10,
        total: 0
    };

    const { page, totalPages, total, limit } = safePagination;

    const pageNumbers = useMemo(() => {
        const pages = [];
        for (let i = Math.max(1, page - 2); i <= Math.min(totalPages, page + 2); i++) {
            pages.push(i);
        }
        return pages;
    }, [page, totalPages]);

    if (totalPages <= 1) return null;

    return (
        <div className="flex items-center justify-between">
            <p className="text-sm text-gray-500 dark:text-gray-400">
                {t('goals.pagination.showing', {
                    from: (page - 1) * limit + 1,
                    to: Math.min(page * limit, total),
                    total
                })}
            </p>
            <div className="flex space-x-2">
                {pageNumbers.map((pageNum) => (
                    <button
                        key={pageNum}
                        onClick={() => onPageChange(pageNum)}
                        className={`px-3 py-1 rounded-lg transition-colors ${pageNum === page
                                ? 'bg-blue-600 text-white'
                                : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700'
                            }`}
                    >
                        {pageNum}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default GoalsPagination;